export default __webpack_public_path__ + "static/media/alignerBQ.df507a54.png";